import {
  CopyTempToLiveBucketRequest,
  CopyTempToLiveBucketResponse,
  CreateDocumentSignerPresignedUrlForUploadRequest,
  CreatePresignedUrlForReadRequest,
  CreatePresignedUrlForReadResponse,
  CreatePresignedUrlForUploadRequest,
  CreatePresignedUrlForUploadResponse,
} from "./S3.dto";
import { S3Url } from "./S3.url";
import { ApiReq } from "../common/flax.types";
import { extractKey, HttpRequest } from "../common/HttpRequest";

export class S3Rest {
  public static async createDocumentSignerPresignedUrlForUpload(
    req: ApiReq<CreateDocumentSignerPresignedUrlForUploadRequest>
  ): Promise<CreatePresignedUrlForUploadResponse> {
    const resp = await HttpRequest.request<CreatePresignedUrlForUploadResponse>(
      process.env.REACT_APP_DOCS_BE_URL,
      ...S3Url.createDocumentSignerPresignedUrlForUpload,
      req,
      {}
    );

    return resp.data;
  }

  public static async createPresignedUrlForUpload(
    req: ApiReq<CreatePresignedUrlForUploadRequest>
  ): Promise<CreatePresignedUrlForUploadResponse> {
    const authorization = extractKey(req, "authorization");

    const resp = await HttpRequest.request<CreatePresignedUrlForUploadResponse>(
      process.env.REACT_APP_DOCS_BE_URL,
      ...S3Url.createPresignedUrlForUpload,
      req,
      { authorization }
    );

    return resp.data;
  }

  public static async createPresignedUrlForRead(req: ApiReq<CreatePresignedUrlForReadRequest>): Promise<CreatePresignedUrlForReadResponse> {
    const authorization = extractKey(req, "authorization");

    const resp = await HttpRequest.request<CreatePresignedUrlForReadResponse>(
      process.env.REACT_APP_DOCS_BE_URL,
      ...S3Url.createPresignedUrlForRead,
      req,
      { authorization }
    );

    return resp.data;
  }

  public static async copyTempToLiveBucket(req: ApiReq<CopyTempToLiveBucketRequest>): Promise<CopyTempToLiveBucketResponse> {
    const authorization = extractKey(req, "authorization");

    const resp = await HttpRequest.request<CopyTempToLiveBucketResponse>(
      process.env.REACT_APP_DOCS_BE_URL,
      ...S3Url.copyTempToLiveBucket,
      req,
      { authorization }
    );

    return resp.data;
  }
}
